import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=37da8391&"
import script from "./HomeBase.vue?vue&type=script&lang=js&"
export * from "./HomeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports